import { Component } from '@angular/core';

@Component({
  selector: 'app-update-multi-auth-success',
  imports: [],
  templateUrl: './update-multi-auth-success.component.html',
  styleUrl: './update-multi-auth-success.component.scss',
})
export class UpdateMultiAuthSuccessComponent {

}
